import * as yup from 'yup'

export interface SeasonChallengeTaskFormData {
  title: string
  actionType: 'quest' | 'tournament_participation' | 'tournament_win' | 'survey' | 'treasure_play' | 'treasure_win' | 'streak' | 'news_vote' | 'game_rating' | 'referral' | 'badge_claim'  | 'shop_purchase' | 'event_notification'
  actionParams?: { [key: string]: any }
  gameSeasonChallengeId?: number
  targetType?: string
  targetId?: string
  streakDays?: string
  minAmount?: string
  articleId?: string
  extra_data?: {
    en?: {
      title?: string
      description?: string
    }
    pt?: {
      title?: string
      description?: string
    }
    translated?: boolean
  }
}

export const seasonChallengeTaskSchema = yup.object().shape({
  title: yup.string().required('El título es requerido'),
  actionType: yup.string().oneOf([
    'quest',
    'tournament_participation', 
    'tournament_win',
    'survey',
    'treasure_play',
    'treasure_win',
    'streak',
    'news_vote',
    'game_rating',
    'referral',
    'badge_claim',
    'shop_purchase',
    'event_notification'
  ]).required('El tipo de acción es requerido'),
  actionParams: yup.object().optional(),
  gameSeasonChallengeId: yup.number().optional(),
  targetType: yup.string().optional(),
  targetId: yup.string().optional().nullable(),
  streakDays: yup.string().when('actionType', {
    is: 'streak',
    then: (schema) => schema.required('El número de días es requerido para streak').matches(/^\d+$/, 'Debe ser un número válido'),
    otherwise: (schema) => schema.optional()
  }),
  minAmount: yup.string().when('actionType', {
    is: 'shop_purchase',
    then: (schema) => schema.optional(),
    otherwise: (schema) => schema.optional()
  }),
  articleId: yup.string().when('actionType', {
    is: 'news_vote',
    then: (schema) => schema.optional(),
    otherwise: (schema) => schema.optional()
  }),
  extra_data: yup.object().shape({
    en: yup.object().shape({
      title: yup.string().optional(),
      description: yup.string().optional()
    }).optional(),
    pt: yup.object().shape({
      title: yup.string().optional(),
      description: yup.string().optional()
    }).optional(),
    translated: yup.boolean().optional()
  }).optional()
})
